import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0f7d0997")

_pushScopeId("data-v-0f7d0997")
const _hoisted_1 = { class: "ui__checkDescrip" }
const _hoisted_2 = { class: "ui__checkDescrip_cont" }
const _hoisted_3 = { class: "ui__checkDescrip_tit" }
const _hoisted_4 = { class: "ui__checkDescrip_txt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, [
        (_ctx.state.icon)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: require(`@/assets/promiseFrame/${_ctx.state.icon}`)
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(_ctx.state.tit), 1)
      ]),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.state.content), 1)
    ])
  ]))
})